import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;

const WELCOME_EMAIL_LOGS_URL = `${API_URL}/welcomeEmailLogs`;

export const getWelcomeEmailLogs = createAsyncThunk(
  "getWelcomeEmailLogs",
  async (
    params: { page?: number; limit?: number; search?: string; status?: string } = {},
    { rejectWithValue, getState }
  ) => {
    try {
      const state = (getState() as any).welcomeEmailLogsList;
      const page = params.page ?? state?.currentPage ?? 1;
      const limit = params.limit ?? 10;
      const search =
        params.search !== undefined ? params.search : state?.search ?? "";
      const status =
        params.status !== undefined ? params.status : state?.statusFilter ?? "";

      const { data } = await axios.get(`${WELCOME_EMAIL_LOGS_URL}/list`, {
        params: { page, limit, search, status },
      });
      return {
        ...data,
        _filters: { search, status, page, limit },
      };
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage || 'Failed to fetch welcome email logs', 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const resendWelcomeEmail = createAsyncThunk(
  "resendWelcomeEmail",
  async (id: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.post(`${WELCOME_EMAIL_LOGS_URL}/resend/${id}`);
      notify(data.responseMessage || 'Welcome email resent successfully', 'success');
      const state = (getState() as any).welcomeEmailLogsList;
      dispatch(
        getWelcomeEmailLogs({
          page: state?.currentPage || 1,
          limit: 10,
          search: state?.search || "",
          status: state?.statusFilter || "",
        })
      );
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage || 'Failed to resend welcome email', 'error');
      return rejectWithValue(error.message);
    }
  }
);
